module.exports = [{
    id: 1,
    avatar: '',
    name: 'TA',
    lastName: '',
    title: 'Excellent services, caring and compassionate',
    review: 'Dr. Highley is very caring and compassionate. Strongly recommend!',
}, {
    id: 2,
    avatar: '',
    name: 'Pmpa97',
    city: '',
    title: 'Dr Highly is very prompt and clinically sound. Easy to assess have access to him.',
    review: 'Excellent consulting md sight with very professional doctor.',
}, {
    id: 3,
    avatar: '',
    name: 'Timy',
    city: '',
    title: 'Cirrus Medical Network , My #1 Choice!',
    review: "I've never had a serious medical problem till now, the past two months, it's been difficult but Dr. Highley was very helpful.",
}, {
    id: 4,
    avatar: '',
    name: 'Justin',
    title: 'CirrusMED was Awesome!',
    review: 'This service is absolutely incredible and I am very thankful for it!',
}, {
    id: 5,
    avatar: '',
    name: 'Bethena',
    title: 'Great',
    review: 'It was great to get a doctor who really was more concerned with the patient versus insurance companies needs@',
}, {
    id: 6,
    avatar: '',
    name: 'Joyce',
    title: 'Right And On Time!',
    review: 'I devoloped an infection on vacation and was in desperate need for an antibiotic. I called several urgent cares and doctors offices for help. The prices ranged from $100 to $150. I came online and within minutes Dr Highley had called me in a prescription for $49. You can’t beat that! I even called back to give an update and he promptly called in a second stronger antibiotic! I’m very happy and satisfied with the service I received.',
}, {
    id: 7,
    avatar: '',
    name: 'Michelle',
    title: 'Very Satisfied!!',
    review: "Honestly one of the easiest, helpful Doc \"visits\" I've ever have. I just wish I would've known about them sooner! Dr. Highley was so caring and understanding and answered any questions I had. I will definitely be using them again!",
}, {
    id: 8,
    avatar: '',
    name: 'Michelle',
    title: 'Live Saving Service',
    review: "This is how medicine should be.... When I was in dire straights trying to find a way to have an ultrasound done when no one else would help me, Cirrus Medicine Network came through. The process was literally seamless from start to finish. It took 5 days from request to results. It was that fast. I requested a one time image referral service for an ultrasound on 3/5/2018, referral came to my email a few hours later, I set up a test with the closest imagining center for the next day and the results came back 3/9/2018. I just want to say thank you from my whole heart, to the entire team and Dr. Highley personally. I appreciate what you are doing! With so much uncertainty in this life, I'm so happy this process doesn't have to be. This service is life saving and a gem in my treasure chest. I will be a patient with them for life. ",
}, {
    id: 9,
    avatar: '',
    name: 'Y',
    title: "Great site, I'd recommend it to anyone needing fast, quality medical services.",
    review: "I used this service to obtain an MRI referral and received it within 24 hours. I also received a consultation and radiology report within 48 hours of getting the MRI. Very fast and professional service (not to mention affordable). I'll definitely use it again.",
}, {
    id: 10,
    avatar: '',
    name: 'Patricia',
    title: 'Dr Highley',
    review: 'I am a reoccurring return patient of Cirrus Medical Network! I have used this status 4 times over the past year and have been assigned to Dr. Highley. He has always been extremely prompt in answering my messages and providing excellent medical care. Besides the quality of care, the cost and and continuity of care is exceptional. Though I have only used one consultant reoccurring plan, CMN offers very affordable plans for those who need a monthly ongoing medical care. The prompt accessibility of a qualified medical clinician and the continuity of care by Dr Highley is reassuring and provides the medical care that more than meets my needs. If there comes a time where my medical issues demand ongoing care by Dr Highley that option is available, which gives me piece of mind. My experience with Dr Highley has been nothing but positive. I highly recommend this concierge medical online service!',
}, {
    id: 11,
    avatar: '',
    name: 'Tj',
    title: 'Very helpful and extremely understanding',
    review: 'Dr. Highley was amazing. His consult focused solely on helping me in the most painless, quick and effective manner. I received a Rx and that process was also painless. The Rx was sent straight to my pharmacy. This is a great network and Dr. Highley was top notch!',
}, {
    id: 12,
    avatar: '',
    name: 'Barbara',
    title: 'Great medical advice and help',
    review: 'It is great to have a doctor available on a schedule that meets my schedule. Dr Highly is easy to talk to and highly professional',
}];



// WEBPACK FOOTER //
// ./src/components/Index/sections/_fakeCustomers.js